import { Directive } from '@angular/core';
import { NavigateRoutes, RequestType } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { ErroModel, GlobalErrorHandlerService } from 'common/services/core_services/error-handler.service';
import { SystemService } from 'common/services/core_services/system.service';

import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomError } from 'common/utils/error';

@Directive()
export class BasePage {
    errModel: ErroModel = new ErroModel();
    globalHandleError: GlobalErrorHandlerService;
    constructor(protected systemService: SystemService) {
        this.globalHandleError = inject(GlobalErrorHandlerService);
        // this.handleError('Errro In Test', 'BasePage');
    }

    handleError(err: any, moduleName: string = 'BasePage') {
        if (document.body.classList.contains('hide-body-overflow')) {
            document.body.classList.remove('hide-body-overflow');
        }

        console.log(err, 'Error Handle Err');

        if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
                this.systemService.showToaster('Your Session is Expired Please Login Again', 'error');
                return;
            }
            this.systemService.showToaster('Something went wrong. Please try after some time', 'error');
        }
        else {
            this.systemService.showToaster(typeof err === 'string' ? err : 'Something Went Wrong.Please try After Some Time', 'error');
        }
    }

    preNavagiateProcess() {
        return new Promise((res, rej) => {
            res(null);
        });
    }

    navigatePage(route: any, dataRes: any = null) {
        this.preNavagiateProcess()
            .then((data) => {
                const message = this.routeMessage();
                message.transferData = dataRes.transferData;
                message.type = dataRes.type;
                this.systemService.routeByUrl(route, message).catch((error) => {
                    this.handleError(error);
                });
            })
            .catch((error) => {
                this.handleError(error);
            });
    }

    routeMessage(): RouteMessage {
        const message = new RouteMessage();
        message.type = RequestType.GET;
        return message;
    }
}
